import type { HTMLChakraProps } from '@chakra-ui/react';
import { Box } from '@chakra-ui/react';
import { useDesiredChain } from '@cronos-app/wallet';
import { TOKEN_LIST } from '@ui/config/token/tokenConfig';
import { useGlobalChainLayer } from '@ui/hooks/useGlobalChainLayer';

import { useTokenSelectDialog } from '../useTokenSelectDialog';
import { TokenListRow } from './TokenListRow';

type TokenListProps = HTMLChakraProps<'div'>;

export const TokenList = (props: TokenListProps) => {
  const chainLayer = useGlobalChainLayer();
  const desiredChain = useDesiredChain(chainLayer);
  const tokenListInStore = useTokenSelectDialog((state) => state.tokenList);
  const tokenList = tokenListInStore ?? TOKEN_LIST[desiredChain];

  return (
    <Box {...props}>
      {tokenList.map((token) => {
        return <TokenListRow key={token} token={token} />;
      })}
    </Box>
  );
};
